import { configureStore, ThunkAction, Action, EnhancedStore } from '@reduxjs/toolkit';
import {
  activityReducer,
  courseReducer,
  adminGroupReducer,
  loginReducer,
  navReducer,
  lessonFlowReducer,
  quizReducer,
  quizUiReducer,
  signupReducer,
  subunitReducer,
  unitReducer,
  modalReducer,
  insightsReducer,
  graderReducer,
  routeGuardReducer,
  studyReducer,
  profileReducer,
} from './slices';

export const makeStore = (): EnhancedStore => {
  return configureStore({
    reducer: {
      isLoggedIn: loginReducer,
      navigation: navReducer,
      modal: modalReducer,
      course: courseReducer,
      unit: unitReducer,
      subunit: subunitReducer,
      activity: activityReducer,
      quiz: quizReducer,
      lessonFlow: lessonFlowReducer,
      quizUi: quizUiReducer,
      study: studyReducer,
      adminGroups: adminGroupReducer,
      signUp: signupReducer,
      insights: insightsReducer,
      grader: graderReducer,
      routeGuard: routeGuardReducer,
      profile: profileReducer,
    },
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
